import script from "./ViewGoToStanding.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewGoToStanding.vue?vue&type=script&setup=true&lang=js"

import "./ViewGoToStanding.vue?vue&type=style&index=0&id=0f9a13ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f9a13ca"]])

export default __exports__